import { makeObservable } from "mobx";

export type EmptyProps = {}

export const applyDecorators = <T extends {}> (target: T) => {
    makeObservable(target);
};